import moment from 'moment';

const toBoolean = (value) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
};

export const buildListQueries = (filters, ownerCustomerId) => {
    const base = {
        ownerCustomerId,
        provider: filters.provider,
        customerId: filters.customerId || undefined,
    };
    return {
        summary: base,
        charges: {
            ...base,
            paid: toBoolean(filters.paid),
            overdue: toBoolean(filters.overdue),
            recurring: toBoolean(filters.recurring),
        },
        subscriptions: {
            ...base,
            active: toBoolean(filters.active),
        },
    };
};

const buildCommandPayload = (form, ownerCustomerId, provider) => ({
    ownerCustomerId,
    provider,
    customerId: Number(form.customerId),
    billingType: form.billingType,
    value: Number(form.value),
    description: form.description || undefined,
    externalReference: form.externalReference || undefined,
});

export const buildChargePayload = (form, ownerCustomerId, provider) => ({
    ...buildCommandPayload(form, ownerCustomerId, provider),
    dueDate: form.dueDate,
});

export const buildSubscriptionPayload = (form, ownerCustomerId, provider) => ({
    ...buildCommandPayload(form, ownerCustomerId, provider),
    nextDueDate: form.nextDueDate,
    cycle: form.cycle,
    endDate: form.endDate || undefined,
    maxPayments: form.maxPayments ? Number(form.maxPayments) : undefined,
});

// Billing dates are calendar days with no timezone; parsing the backend's midnight-UTC timestamp would shift them a day back in BRT.
export const dateOnly = (value) => (value ? moment(String(value).slice(0, 10), 'YYYY-MM-DD') : null);

export const formatCurrency = (intl, value) => {
    if (value === null || value === undefined) return intl.formatMessage({id: 'notAvailable'});
    return new Intl.NumberFormat(
        intl.locale === 'pt' ? 'pt-BR' : 'en-US',
        {style: 'currency', currency: 'BRL', minimumFractionDigits: 2},
    ).format(Number(value));
};

export const formatDateValue = (intl, value) => {
    if (!value) return intl.formatMessage({id: 'notAvailable'});
    return dateOnly(value).format(intl.formatMessage({id: 'dateFormat'}));
};

export const whatsappPhone = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    return digits.length === 10 || digits.length === 11 ? `55${digits}` : digits;
};
